//
// Turns rich text fields into Quill editors and syncs their HTML to a hidden input on submit.
// Markup: <div data-rich-text-input="input-id"></div> next to <input type="hidden" id="input-id">.
//
import Quill from 'quill';

const Link = Quill.import('formats/link');

// Links typed without a scheme get https://, and only https and mailto links are allowed.
class SecureLink extends Link {

	static PROTOCOL_WHITELIST = ['https', 'mailto'];

	static sanitize(url) {

		let value = url.trim();
		if (!/^[a-z][a-z0-9+.-]*:/i.test(value)) {
			value = 'https://' + value.replace(/^\/+/, '');
		}

		return super.sanitize(value);
	}
}

Quill.register(SecureLink, true);

const TOOLBAR = [
	[{ header: [2, 3, false] }],
	['bold', 'underline'],
	[{ list: 'ordered' }, { list: 'bullet' }],
	['link', 'blockquote'],
	['clean']
];

// Keep in sync with the allowlist in \System\RichText.
const FORMATS = ['header', 'bold', 'underline', 'list', 'link', 'blockquote'];

window.addEventListener('DOMContentLoaded', () => {

	document.querySelectorAll('[data-rich-text-input]').forEach((element) => {

		const input = document.getElementById(element.dataset.richTextInput);
		if (!input || !input.form) {
			return;
		}

		const quill = new Quill(element, {
			theme: 'snow',
			modules: { toolbar: TOOLBAR },
			formats: FORMATS
		});

		if (input.value) {
			// Convert instead of pasting so the editor does not grab focus on page load.
			quill.setContents(quill.clipboard.convert({ html: input.value }), 'silent');
		}

		input.form.addEventListener('submit', () => {

			// An empty editor still holds a single newline.
			if (quill.getText().trim() === '') {
				input.value = '';
				return;
			}

			// Quill 2.0.3 writes every space as &nbsp;, which stops the text from wrapping.
			input.value = quill.getSemanticHTML().replaceAll('&nbsp;', ' ');
		});
	});
});
